import React from "react";
import styles from "../../Styles/creator/styles.module.css";
// import play from "../../images/video.jpg";
import delbtn from "../../images/delbtn.svg";
import ViewModal from "../Modals/ViewModal";
import axios from "axios";
import Popover from "@mui/material/Popover";
import { Typography } from "@mui/material";
import { API } from "../../backend";

function Video({ del, video, list, setStatus, toast }) {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const popen = Boolean(anchorEl);

  const handleDelete = () => {
    var data = JSON.stringify({
      id: `${list._id}`,
      videoName: `${video?.videoName}`,
    });
    console.log(data, "data");
    var config = {
      method: "put",
      url: `${API}/playlist/remove`,
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("_access_token")
        )}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(response, "response delete");
        if (response.status === 200) {
          setStatus(true);
          toast("Video Deleted Successfully");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          setStatus(false);
          toast("Some Error Occured");
        }
      })
      .catch(function (error) {
        setStatus(false);
        toast("Some Error Occured");
      });
  };

  return (
    <div className={styles.video}>
      <div className={styles.image} onClick={() => setOpen((val) => !val)}>
        <img src={video?.thumbnail} alt="" />
      </div>
      <div className={styles.text3}>
        <span>{video?.title}</span>
        <br />
        {/* <span>-Part 1</span> */}
      </div>
      {del && (
        // eslint-disable-next-line jsx-a11y/role-supports-aria-props
        <img
          src={delbtn}
          alt="%"
          className={styles.dele}
          onClick={handleDelete}
          aria-owns={popen ? "mouse-over-popover" : undefined}
          aria-haspopup="true"
          // onMouseEnter={handlePopoverOpen}
          // onMouseLeave={handlePopoverClose}
        />
      )}
      {/* <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: "none",
        }}
        open={popen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography sx={{ p: 1 }}>Delete</Typography>
      </Popover> */}
{open && (
  <ViewModal
    open={open}
    setOpen={setOpen}
    videoUrl={video?.videoName} 
  />
)}

{console.log("VIDEO OBJECT:", video)}
    </div>
  );
}
export default Video;
